interface TouristSpot {
  name?: string;
  address?: string;
  distance?: number;
  description?: string;
  title?: string;
  latitude: number;
  longitude: number;
}

interface Props {
  id: number;
  item: TouristSpot;
}

const DestinationInfoBox = ({ id, item }: Props) => {
  return (
    <div className="border-b mobile:border-none border-[#BDBDBD]">
      <div className="flex items-center gap-[8px]">
        <div className="size-[24px] mobile:size-[17px] flex justify-center items-center text-[14px] mobile:text-[12px] border border-[#929292] rounded-[5px]">
          {id}
        </div>
        <div className="text-[20px] mobile:text-[14px] font-[600]">
          {item?.name}
        </div>
        <div className="text-[14px] text-[#767676] hidden mobile:block">
          {item?.address}
        </div>
        <div className="text-[14px] text-[#767676]  mobile:hidden">
          {Math.round((item?.distance ?? 0) * 10) / 10} km
        </div>
      </div>
      <div className="text-[14px] text-[#767676] mobile:hidden">
        {item?.address}
      </div>

      <div className="pb-[10px] mobile:text-[12px] mobile:ml-[24px]">
        <div className="hidden mobile:flex">
          {/* <div className="hidden mobile:block size-[24px] mobile:size-[17px]"></div> */}
          <div className="text-[#767676]">
            {Math.round((item?.distance ?? 0) * 10) / 10} km
          </div>
        </div>
        <div className="flex">
          {/* <div className="hidden mobile:block size-[24px] mobile:size-[17px]"></div> */}
          <div className="text-[16px]"></div>
          {item?.description}
        </div>
      </div>
    </div>
  );
};

export default DestinationInfoBox;
